import { render } from "./PCConfiguracionPuntoPaletizado.vue?vue&type=template&id=787b24a4&scoped=true"
import script from "./PCConfiguracionPuntoPaletizado.vue?vue&type=script&lang=js"
export * from "./PCConfiguracionPuntoPaletizado.vue?vue&type=script&lang=js"

import "./PCConfiguracionPuntoPaletizado.vue?vue&type=style&index=0&id=787b24a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787b24a4"]])

export default __exports__